import { CODEMIRROR_PACKAGE_SPECS, TIPTAP_PACKAGE_VERSION_SPEC } from '@cli-constants/deps.js'
import { isTiptapPackageName } from './is-tiptap-package-name.js'

export function getAlignedPackageSpec(name: string): string | null {
  if (isTiptapPackageName(name)) {
    return `${name}@${TIPTAP_PACKAGE_VERSION_SPEC}`
  }

  const versionSpec = CODEMIRROR_PACKAGE_SPECS[name]
  return versionSpec ? `${name}@${versionSpec}` : null
}
